<template>
    <div class="relative">
        <v-spa-loader
            v-if="loaders.contact.isLoading"
            background-color="bg-gray-50"
        />
        <form @submit.prevent="loadAndSubmit">
            
            <div class="grid grid-cols-3 gap-2">
                <!-- HONORIFIC KEY -->
                <form-field-component
                    name="honorific_key"
                    :options="completeOptions"
                    v-slot="{ inputName }"
                >
                    <v-spa-element :id="inputName" :form="form" :input-name="inputName" :label="$t('form.labels.honorific')">
                        <select v-model="form[inputName]" :class="$spa.css.form.select" :id="inputName">
                            <option :value="null">{{ $t('form.placeholders.select') }}</option>
                            <option :value="honorific" v-for="(label, honorific) in honorifics" :key="honorific">
                                {{ label }}
                            </option>
                        </select>
                    </v-spa-element>
                </form-field-component>
                
                <!-- NAME -->
                <form-field-component
                    name="name"
                    :options="completeOptions"
                    v-slot="{ inputName }"
                    class="col-span-2"
                >
                    <v-spa-input
                        :form="form"
                        :input-name="inputName"
                        :id="inputName"
                        :placeholder="$t('form.placeholders.name')"
                        :label="$t('form.labels.name')"
                    />
                </form-field-component>
            </div>
            
            <!-- PROFESSIONAL CHECKBOX -->
            <form-field-component
                name="is_professional"
                :options="completeOptions"
                v-slot="{ inputName }"
            >
                <v-spa-checkbox
                    :form="form"
                    :input-name="inputName"
                    :id="inputName"
                    :placeholder="$t('form.placeholders.is_professional')"
                    :label="$t('form.labels.is_professional')"
                />
            </form-field-component>

            <template v-if="form.is_professional">  
                
                <!-- VAT NUMBER -->
                <form-field-component
                    name="vat_number"
                    :options="completeOptions"
                    v-slot="{ inputName }"
                >
                    <v-spa-input
                        :form="form"
                        :input-name="inputName"
                        :id="inputName"
                        :placeholder="$t('form.placeholders.company_vat_number')"
                        :label="$t('form.labels.company_vat_number')"
                    />
                </form-field-component>

                <!-- COMPANY -->
                <form-field-component
                    name="company_name"
                    :options="completeOptions"
                    v-slot="{ inputName }"
                >
                    <v-spa-input
                        :form="form"
                        :input-name="inputName"
                        :id="inputName"
                        :placeholder="$t('form.placeholders.company_name')"
                        :label="$t('form.labels.company_name')"
                    />
                </form-field-component>

            </template>
            
            <!-- EMAIL -->
            <form-field-component
                name="email"
                :options="completeOptions"
                v-slot="{ inputName }"
            >
                <v-spa-input
                    :form="form"
                    :input-name="inputName"
                    :id="inputName"
                    :placeholder="$t('form.placeholders.email')"
                    :label="$t('form.labels.email')"
                />
            </form-field-component>
            
            <!-- PHONE NUMBER -->
            <form-field-component
                name="phone_number"
                :options="completeOptions"
                v-slot="{ inputName }"
            >
                <v-spa-input
                    :form="form"
                    :input-name="inputName"
                    :id="inputName"
                    :placeholder="$t('form.placeholders.phone_number')"
                    :label="$t('form.labels.phone_number')"
                />
            </form-field-component>

            <div class="grid grid-cols-2 gap-2">
                
                <!-- ADDRESS LINE 1 -->
                <form-field-component
                    name="address_line_1"
                    :options="completeOptions"
                    v-slot="{ inputName }"
                >
                    <v-spa-input
                        :form="form"
                        :input-name="inputName"
                        :id="inputName"
                        :placeholder="$t('form.placeholders.address_line_1')"
                        :label="$t('form.labels.address_line_1')"
                    />
                </form-field-component>
                
                <!-- ADDRESS LINE 2 -->
                <form-field-component
                    name="address_line_2"
                    :options="completeOptions"
                    v-slot="{ inputName }"
                >
                    <v-spa-input
                        :form="form"
                        :input-name="inputName"
                        :id="inputName"
                        :placeholder="$t('form.placeholders.address_line_2')"
                        :label="$t('form.labels.address_line_2')"
                    />
                </form-field-component>
            </div>
            <div class="grid grid-cols-2 gap-2">
                
                <!-- POSTAL CODE -->
                <form-field-component
                    name="postal_code"
                    :options="completeOptions"
                    v-slot="{ inputName }"
                >
                    <v-spa-input
                        :form="form"
                        :input-name="inputName"
                        :id="inputName"
                        :placeholder="$t('form.placeholders.postal_code')"
                        :label="$t('form.labels.postal_code')"
                    />
                </form-field-component>

                <!-- CITY -->
                <form-field-component
                    name="city"
                    :options="completeOptions"
                    v-slot="{ inputName }"
                >
                    <v-spa-input
                        :form="form"
                        :input-name="inputName"
                        :id="inputName"
                        :placeholder="$t('form.placeholders.city')"
                        :label="$t('form.labels.city')"
                    />
                </form-field-component>
            </div>
            
            <!-- COUNTRY -->
            <form-field-component
                name="country"
                :options="completeOptions"
                v-slot="{ inputName }"
            >
                <v-spa-element :id="inputName" :form="form" :input-name="inputName" :label="$t('form.labels.country')">
                    <select v-model="form[inputName]" :class="$spa.css.form.select" :id="inputName">
                        <option :value="null">{{ $t('form.placeholders.select') }}</option>
                        <option :value="country" v-for="(label, country) in countries" :key="country">
                            {{ label }}
                        </option>
                    </select>
                </v-spa-element>
                <!-- <v-spa-input
                    :form="form"
                    :input-name="inputName"
                    :id="inputName"
                    :placeholder="$t('form.placeholders.country')"
                    :label="$t('form.labels.country')"
                /> -->
            </form-field-component>

            <!-- CONTACT TYPE -->
            <form-field-component
                name="types"
                :options="completeOptions"
                v-slot="{ inputName }"
            >
                <v-spa-multiselect
                    :form="form"
                    :input-name="inputName"
                    :id="inputName"
                    :label="$t('form.labels.contacts.types')"
                    :options="contact_types"
                    track-by="name"
                    option-label="label"
                    :close-on-select="true"
                    class="max-w-input"
                />
            </form-field-component>
            
            <!-- COMMENTS -->
            <form-field-component
                name="comments"
                :options="completeOptions"
                v-slot="{ inputName }"
            >            
                <v-spa-textarea
                    :form="form"
                    :input-name="inputName"
                    :id="inputName"
                    :placeholder="$t('form.placeholders.comments')"
                    :label="$t('form.labels.comments')"
                />
            </form-field-component>
            
            <div class="grid justify-end">
                <v-spa-loading-button :loading="loaders.submit.isLoading" :disabled="!submittable">
                    {{ submitButtonText }}
                </v-spa-loading-button>
            </div>
        </form>
    </div>
</template>

<script>
import Form from "@spa/classes/Form";
import { Contact, Type } from "@spa/api/app/contact";
import { Loader } from "@henrotaym/helpers";
import { formProps } from "./mixin";
import FormFieldComponent from "./FormField.vue"

export default {
    props: { ...formProps },
    components: { FormFieldComponent },
    data() {
        return {
            /** @type {Form} */
            form: {},
            /** @type {Contact} */
            contact: {},
            loaders: { 
                submit: new Loader(false),
                contact: new Loader(false)
            },
            contact_types: new Type().translatedStaticIndex(),
            /** 
             * Form options with default values.
             * @type {import("@spa/types/components").CompleteContactFormOptions}
             */
            defaultOptions: { hide: {} }
        }
    },
    methods: {
        async submit() {
            /** @type {import('@spa/types/api/app/contact').ContactNotPersistedInterface} */
            const contact = this.form.data();
            /**
             * Form class is overiding options fields..
             * @todo Don't set options to null if there's any option (not form class options obviously).
             */
            contact.options = null;
            const response = await this.contact[this.formAction](contact);
            if (!response) return window.Toasteo.error("Could not process contact.");
            
            this.updateValue({ response, contact });
        },
        async loadAndSubmit() {
            this.loaders.submit.loadTill(this.submit);
        },

        updateValue({ contact, response }) {
            contact.uuid = response.uuid;
            this.$emit(`${this.formAction}d`, contact);
            this.$emit(`submitted`, contact);
        },
        async setForm() {
            const contact = await this.getContact()
            if (!contact) return;
            this.form = new Form(contact);
        },
        async getContact() {
            if (this.isCreate) return this.onInit(this.contact.new());

            const contact = await this.loaders.contact.loadTill(() => this.contact.show(this.uuid));
            if (!contact) return window.Toasteo.error(`Could not find contact [${this.uuid}].`);

            return this.onInit(this.contact.copy(contact));
        },
    },
    computed: {
        isCreate() {
            return !this.uuid;
        },
        formAction() {
            return this.isCreate ? "store" : "update";
        },
        submittable() {
            const { name, types } = this.form;

            return !!(name && types?.length);
        },
        submitButtonText() {
            return this.$t(`form.buttons.${this.isCreate ? "create" : "edit"}`);
        },
        completeOptions() {
            return {
                ...this.defaultOptions,
                ...this.options
            }
        },
        honorifics() {
            return this.$t('honorifics');
        },
        countries() {
            return this.$t('countries');
        }
    },
    watch: {
        /** Making sure professional related fields are reset when switching off. */
        ['form.is_professional'](isProfessional) {
            if(isProfessional) return;
            this.form.company_name = this.form.vat_number = null;
        }
    },
    created() {
        this.contact = new Contact();
        this.setForm();
    }
}
</script>
